// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_a7-3";
export var contentContainer = "_a7-0";
export var editorContainer = "_a7-1";
export var quillInputForm = "_a7-2";
export var zoneDivider = "_a7-4";